/**
 * 店长导航
 */
export default {
  MULTIDIMSREPORT: {
    component: () => import(
      /* webpackChunkName: 'reportCenter' */
      'allpages/reportCenter/2dReport/index.vue'
    ),
    // labelName: $it('menu.ae')
    labelName: '多维度报表',
  },
  CUS_RPT_RETAIL_PAY_TYPE: {
    component: () => import(
      /* webpackChunkName: 'reportCenter' */
      'allpages/reportCenter/CUS_RPT_RETAIL_SUM.vue'
    ),
    labelName: '零售付款方式查询'
  },
  CUS_RPT_RETAIL_STORAGE: {
    component: () => import(
      /* webpackChunkName: 'reportCenter' */
      'allpages/reportCenter/CUS_RPT_RETAIL_SUM.vue'
    ),
    labelName: '零售库存汇总'
  },
  CUS_RPT_RETAIL_SUM: {
    component: () => import(
      /* webpackChunkName: 'reportCenter' */
      'allpages/reportCenter/CUS_RPT_RETAIL_SUM.vue'
    ),
    labelName: '零售汇总'
  },
  STOREMANAGE: {
    component: () => import(
      /* webpackChunkName: 'reportCenter' */
      'allpages/reportCenter/managerNav/index.vue' // 店长导航
    ),
  },
};
